import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'

import {
  teamAvailabilities,
  fetchTeamAvailabilitiesSucceeded,
  fetchTeamAvailabilitiesPending,
} from 'app/modules/teams/selectors'
import { fetchTeamAvailabilities } from 'app/modules/teams/actions'

const mapStateToProps = state => ({
  teamAvailabilities: teamAvailabilities(state),
  doFetchTeamAvailabilities:
    !fetchTeamAvailabilitiesSucceeded(state) && !fetchTeamAvailabilitiesPending(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchTeamAvailabilities,
    },
    dispatch
  ),
})

const withOrgTeams = WrappedComponent =>
  compose(
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle({
      componentDidMount() {
        const { actions, doFetchTeamAvailabilities } = this.props
        if (doFetchTeamAvailabilities) {
          actions.fetchTeamAvailabilities()
        }
      },
    })
  )(WrappedComponent)

export default withOrgTeams



// WEBPACK FOOTER //
// ./src/scripts/app/modules/teams/hoc/withOrgTeamAvailabilities.js